import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchContactContent } from 'Components/InfoContact/Redux/thunks';
import InfoContact from 'Components/InfoContact/InfoContact';

import { 
  getIsFetchingContact, 
  getFetchContactFailed, 
  getContactContent,
} from 'Components/InfoContact/Redux/selectors';

interface IProps {
  simplified?: boolean;
}

interface IPropsInternal {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.ContactPageViewModel;
  fetchContactContent: () => void;
}

type Props = IProps & IPropsInternal;

class InfoContactContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchContactContent();
  }

  render() {
    return (
      <InfoContact
        isFetching={ this.props.isFetching }
        isFetchFailed={ this.props.isFetchFailed }
        simplified={ this.props.simplified }
        content={ this.props.content }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetchingContact(state),
    isFetchFailed: getFetchContactFailed(state),
    content: getContactContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchContactContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoContactContainer);


// WEBPACK FOOTER //
// ./src/components/InfoContact/InfoContactContainer.tsx